export enum AuthenticationExperience {
    FullRedirect = 'FullRedirect',
    Iframe = 'Iframe',
    NewTab = 'NewTab',
}
